const tagFields = {
  name: "Nome",
  color: "Cor",
};

const tagErrors = {
  TAG_IN_USE:
    "Não é possível excluir a tag pois está em uso por %{usageCount} registro(s). Remova a tag de todos os registros primeiro.",
  deleteFailed: "Erro ao excluir tag",
  updateFailed: "Erro ao atualizar tag",
};

export const tag = {
  name: "Tag |||| Tags",
  label: "Tags",
  fields: {
    ...tagFields,
    domain: "Domínio",
  },
  domain: {
    ticket: "Ticket",
    conversation: "Conversa",
    job_application: "Vaga",
  },
  errors: tagErrors,
};

export const ticketTag = {
  name: "Tag de Ticket |||| Tags de Ticket",
  fields: tagFields,
  errors: tagErrors,
};

export const conversationTag = {
  name: "Tag de Conversa |||| Tags de Conversa",
  fields: tagFields,
  errors: tagErrors,
};

export const jobApplicationTag = {
  name: "Tag de Vaga |||| Tags de Vaga",
  fields: tagFields,
  errors: tagErrors,
};
